import { DependencyList, useCallback, useEffect, useState } from 'react';
import _debounce from 'lodash.debounce';

// useMemo() but with debounce
// https://github.com/SevenOutman/use-debounced-memo

export interface IUseDebouncedMemoOptions {
    leading?: boolean;
}

export const useDebouncedMemo = <T>(factory: () => T, deps: DependencyList | undefined, debounceMs: number, options?: IUseDebouncedMemoOptions): T => {

    const [state, setState] = useState(factory());

    const debouncedSetState = useCallback(_debounce(setState, debounceMs, { leading: options?.leading }), []);

    useEffect(() => {
        debouncedSetState(factory());
    }, deps);

    return state;
}
